var map = {
	"./banner-darkgray.png": 79349,
	"./banner-gray.png": 22557,
	"./banner-tutor.png": 67950,
	"./banner-white.png": 80641,
	"./check_white.png": 88653,
	"./close.png": 99555,
	"./down-gray.png": 63943,
	"./english-top-banner.png": 52806,
	"./global-top-banner.png": 84169,
	"./minus.png": 74999,
	"./more.png": 63884,
	"./plus.png": 38431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58652;